document.addEventListener('DOMContentLoaded', function () {
  // Query-Params holen
  var q = new URLSearchParams(window.location.search);

  // Helper: plus->Leerzeichen & decode
  function de(v){ return v ? decodeURIComponent(String(v).replace(/\+/g, ' ')) : ''; }

  // Werte aus URL
  var product     = de(q.get('product'));
  var variant     = de(q.get('variant'));
  var sku         = de(q.get('sku'));
  var product_url = de(q.get('product_url'));

  // Produkt-Feld finden (deins heißt name="contact[produkt]")
  var produktInput =
    document.querySelector('input[name="contact[produkt]"]')
    || document.querySelector('#template--26465376600402__contact-form-contact-field-5');

  if (produktInput && !produktInput.value && product) {
    produktInput.value = product;
  }

  // Optional: Hidden-Felder automatisch füllen, falls vorhanden
  var vInput  = document.querySelector('input[name="contact[variant]"]');
  var sInput  = document.querySelector('input[name="contact[sku]"]');
  var uInput  = document.querySelector('input[name="contact[produkt_url]"]');

  if (vInput && !vInput.value && variant)     vInput.value = variant;
  if (sInput && !sInput.value && sku)         sInput.value = sku;
  if (uInput && !uInput.value && product_url) uInput.value = product_url;
});
